/**
 * `items` with the element at `from` moved to `to` (clamped to the list). Pure:
 * returns a new array, and an unchanged copy when `from` is out of range.
 */
export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  const result = [...items];
  if (from < 0 || from >= result.length) return result;
  const [moved] = result.splice(from, 1);
  const at = Math.max(0, Math.min(Math.trunc(to), result.length));
  result.splice(at, 0, moved);
  return result;
}
